<script>
  import { onMount } from "svelte";
  import {M} from "../external";

  export let order = null,
    item = null;

  export function getSelectedItem() {
    return item;
  }

  onMount(() => {
    // item.price is the total price for this item, not the single price. 
    // we want to have the single item price in the quantity field.
    if (item.quantity !== 0) {
      item.price = item.price / item.quantity;
    }
  });
</script>

<div class="popup-widget-wrapper">
  <div class="col20 f-left t-center mt-5">
    <span class="material-icons-outlined fingerprint-icon"> invert_colors </span>
  </div>
  <h4 class="col20 f-left mt-15 mb-10 t-center h4-bigger">{item.title}</h4>
  <span class="light-gray-text t-center col20 f-left mb-25 padded-text">{M.SELECT_QTY_VARIATION}</span>

  {#each item.variation as variation}
    <div class="popup-input-wrapper f-left mt-15">
      <div class="info">
        <h5>{variation.name}</h5>
        <span>{variation.value}</span>
      </div>
    </div>
  {/each}

  {#each item.additions as addition}
    <div class="popup-input-wrapper f-left mt-15">
      <div class="info">
        <h5>{addition.name}</h5>
        <span>{addition.value}</span>
      </div>
    </div>
  {/each}

  <div class="popup-input-wrapper col9n">
    <h5>{M.PRODUCT_PRICE}</h5>
    <input type="number" bind:value={item.price} min="0" step="0.1" />
  </div>
  <div class="popup-input-wrapper col9n f-right">
    <h5>{M.QUANTITY}</h5>
    <input type="number" bind:value={item.quantity} min="1" step="1" />
  </div>
</div>
